export const STATUS_TEXT_MAP = {
  DeclineToQuote: "Decline to quote",
  NotTakenUp: "Not taken up",
  QuotedReferred: "Referred quoted",
  QuoteExpired: "Quote expired",
  Submitted: "In progress",
};

export default STATUS_TEXT_MAP;
